import type { PrioritizationResult } from '@core-api/presentation/types/response';
import type { SlidePreviewResultsInputs } from '../../types';

export const getPreviewResultsIteration = ({
  previous = [],
  iteration,
  extras: { choices },
}: SlidePreviewResultsInputs<PrioritizationResult>): PrioritizationResult[] => {
  if (iteration === 0 || previous.length === 0) {
    return choices.map(({ interactiveContentChoiceId }) => ({
      interactiveContentChoiceId,
      value: 0,
    }));
  }

  let totalScore = 100;
  return choices.map(({ interactiveContentChoiceId }, i) => {
    const score =
      i === choices.length - 1
        ? totalScore
        : Math.floor(Math.random() * totalScore);
    totalScore -= score;
    return { interactiveContentChoiceId, value: score };
  });
};
